import * as React from "react";
import { cn } from "lib/utils";

export interface InputProps extends Omit<React.ComponentProps<"input">, "size"> {
  size?: "default" | "sm";
}

const sizeClasses: Record<NonNullable<InputProps['size']>, string> = {
  default: "",
  sm: "px-3 py-2 text-[0.8125rem] leading-5 text-xs",
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex w-full rounded-xl border border-input px-3 py-2 text-sm leading-none placeholder:text-xs shadow-sm transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          sizeClasses[size],
          type === "number" &&
            '[&::-webkit-inner-spin-button]:ml-1 [&::-webkit-outer-spin-button]:ml-1',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };

